import 'slick-carousel';

const slickPrevArrow =
  `<button type="button" class="btn hero-slider-slick__btn slick-prev">
    <svg class="svg-left-arrow" viewBox="0 0 25 41" id="left-arrow" style="transform: rotateY(180deg)">
      <polygon points="25 20.5 3.49 0 0 3.26 18.05 20.5 0 37.75 3.49 41 25 20.5"/>
    </svg>
  </button>`;

const slickNextArrow =
  `<button type="button" class="btn hero-slider-slick__btn slick-next">
    <svg class="svg-right-arrow" viewBox="0 0 25 41" id="right-arrow">
      <polygon points="25 20.5 3.49 0 0 3.26 18.05 20.5 0 37.75 3.49 41 25 20.5"/>
    </svg>
  </button>`;

const slickSliderOptions = {
  lazyLoad: 'ondemand',
  dots: false,
  fade: true,
  cssEase: 'linear',
  appendArrows: $('.hero-slider-slick-nav .container'),
  prevArrow: slickPrevArrow,
  nextArrow: slickNextArrow,
};

$('.hero-slider.slick-slider').first().slick(slickSliderOptions);
